import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { FilterValues } from 'src/app/shared/components/filter/filter.component';
import { EStampService } from 'src/app/core/services/e-stamp.service';
import { ToastService } from 'src/app/core/services/toast.service';
@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrl: './inventory.component.scss',
    standalone: false
})
export class InventoryComponent {

  loading = false;
  inventory = [];
  orderDetail: any = {};

  showModal: boolean = false;
  @ViewChild('dt') table!: Table;


  constructor(
    private estampService: EStampService,
    private router: Router,
    private toastService: ToastService,
  ) { }

  getInventory(event: LazyLoadEvent) {
    Promise.resolve().then(() => this.loading = true);
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }
    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    }

    this.estampService.getInventoryList(queryParams).subscribe(
      (res: any) => {
        this.loading = false;
        this.inventory = res?.data;
        this.totalRecords = res?.totalCount || 0;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  closeModal() {
    this.showModal = false;
  }

  previewFile(document: any) {
    if (document?.pdfUrl) {
      window.open(document.pdfUrl, '_blank');
    }
  }


  totalRecords = 0;
  rows = 10;
  searchText: any = '';
  selectedStatus: any = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Utilized', value: 'UTILIZED' },
    { label: 'Allocated', value: 'ALLOCATED' }
  ];


  onFilterChange(values: FilterValues) {
    this.searchText = values.search;
    this.selectedStatus = values.status;
    this.rangeDates = values.dateRange;
    this.table.reset();
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }


  getStatusClass(status: string): any {
    switch (status) {
      case 'ORDER_CREATED':
        return 'border-secondary text-secondary bg-light';

      case 'UNDER_REVIEW':
      case 'UNDER_CHECKER_REVIEW':
        return 'border-warning text-warning bg-warning-subtle';

      case 'INVOICE_GENERATED':
        return 'border-info text-info bg-info-subtle';

      case 'PAYMENT_SUBMITTED':
        return 'border-primary text-primary bg-primary-subtle';

      case 'PAYMENT_REJECTED':
        return 'border-danger text-danger bg-danger-subtle';

      case 'PAYMENT_VERIFIED':
        return 'border-success text-success bg-success-subtle';

      case 'ESTAMP_UPLOADED':
        return 'border-purple text-purple bg-purple-subtle';

      case 'COMPLETED':
        return 'border-success text-success bg-success-subtle';

      default:
        return 'border-dark text-dark bg-light';
    }
  }
}
